var map = {
	"./customerOrderReviews_en.js": [
		"nNsa",
		109
	],
	"./customerOrderReviews_zh.js": [
		"stNu",
		110
	],
	"./en-US/accountSettings.js": [
		"ccKS",
		194
	],
	"./en-US/action.js": [
		"pc3g",
		205
	],
	"./en-US/activities.js": [
		"btKx",
		215
	],
	"./en-US/adjustment.js": [
		"1DTV",
		226
	],
	"./en-US/adyenMonthlyReport.js": [
		"qsSm",
		237
	],
	"./en-US/alternativePayments.js": [
		"MiBC",
		248
	],
	"./en-US/appConfig.js": [
		"evOI",
		258
	],
	"./en-US/breakManagement.js": [
		"Ed//",
		268
	],
	"./en-US/cashStatement.js": [
		"tdoG",
		111
	],
	"./en-US/categories.js": [
		"tkuI",
		122
	],
	"./en-US/cfdSettings.js": [
		"FFtC",
		133
	],
	"./en-US/common.js": [
		"jzkA",
		143
	],
	"./en-US/component.js": [
		"OZF3",
		154
	],
	"./en-US/customerPickupScreenSettings.js": [
		"XWsH",
		165
	],
	"./en-US/customizations.js": [
		"z4Kg",
		176
	],
	"./en-US/deliveryPlatformOrderingSettings.js": [
		"SCyG",
		186
	],
	"./en-US/department.js": [
		"qtCA",
		192
	],
	"./en-US/devices.js": [
		"mIru",
		193
	],
	"./en-US/discount.js": [
		"uPa3",
		195
	],
	"./en-US/dishEdit.js": [
		"z44p",
		196
	],
	"./en-US/dishPreference.js": [
		"alD+",
		197
	],
	"./en-US/dynamicRateFeeReport.js": [
		"pBlF",
		198
	],
	"./en-US/fee.js": [
		"uQlS",
		199
	],
	"./en-US/filter.js": [
		"7Jh9",
		200
	],
	"./en-US/floorPlan.js": [
		"DlPA",
		201
	],
	"./en-US/formula.js": [
		"+1eF",
		202
	],
	"./en-US/giftcardReport.js": [
		"qNP/",
		203
	],
	"./en-US/globalHeader.js": [
		"RyAV",
		204
	],
	"./en-US/globalPreferenceSettings.js": [
		"xyo2",
		206
	],
	"./en-US/home.js": [
		"SoAr",
		207
	],
	"./en-US/kitchenDisplayScreenSettings.js": [
		"71PK",
		208
	],
	"./en-US/loyalty.js": [
		"L3Da",
		81
	],
	"./en-US/loyaltyMember.js": [
		"BNOj",
		209
	],
	"./en-US/loyaltySettings.js": [
		"wOVg",
		210
	],
	"./en-US/member.js": [
		"AJ00",
		211
	],
	"./en-US/menu.js": [
		"Tqn2",
		212
	],
	"./en-US/menuBuilder.js": [
		"eN9v",
		213
	],
	"./en-US/menuDecorate.js": [
		"b0DV",
		214
	],
	"./en-US/menuDecorationPreview.js": [
		"vafY",
		216
	],
	"./en-US/menuManagement.js": [
		"6Wp+",
		217
	],
	"./en-US/menuSettings.js": [
		"kSYp",
		218
	],
	"./en-US/monthlyStatement.js": [
		"TeyH",
		219
	],
	"./en-US/onlineOrderingSettings.js": [
		"Xl0Y",
		220
	],
	"./en-US/order.js": [
		"1xgO",
		221
	],
	"./en-US/orderDetail.js": [
		"9XyC",
		222
	],
	"./en-US/orderReviews.js": [
		"fmYF",
		223
	],
	"./en-US/password.js": [
		"wqW7",
		224
	],
	"./en-US/payout.js": [
		"R/Px",
		225
	],
	"./en-US/payoutFeeReport.js": [
		"lQbx",
		227
	],
	"./en-US/permission.js": [
		"ApO0",
		228
	],
	"./en-US/permissionManagement.js": [
		"hEF5",
		229
	],
	"./en-US/prepaidTransactions.js": [
		"obtZ",
		230
	],
	"./en-US/priceEditor.js": [
		"LdJ7",
		231
	],
	"./en-US/printTemplate.js": [
		"x7ii",
		232
	],
	"./en-US/printer.js": [
		"dKeP",
		233
	],
	"./en-US/printerLogs.js": [
		"vco3",
		234
	],
	"./en-US/printerMapping.js": [
		"7lPJ",
		235
	],
	"./en-US/printoutSettings.js": [
		"Y9IH",
		236
	],
	"./en-US/promotionManagement.js": [
		"cKwV",
		238
	],
	"./en-US/promotionSettings.js": [
		"MLM9",
		239
	],
	"./en-US/quickNotes.js": [
		"pHWg",
		240
	],
	"./en-US/reportsSettings.js": [
		"zJFL",
		241
	],
	"./en-US/request.js": [
		"I8gT",
		242
	],
	"./en-US/reservationSettings.js": [
		"O77S",
		243
	],
	"./en-US/resetPassword.js": [
		"gLD5",
		244
	],
	"./en-US/rgReport.js": [
		"YPfk",
		245
	],
	"./en-US/role.js": [
		"lx53",
		246
	],
	"./en-US/salesCategory.js": [
		"kC3N",
		247
	],
	"./en-US/salesReport.js": [
		"jJe4",
		249
	],
	"./en-US/salesSummary.js": [
		"0+tm",
		250
	],
	"./en-US/servicePeriod.js": [
		"BzNX",
		251
	],
	"./en-US/serviceSettings.js": [
		"bUf0",
		252
	],
	"./en-US/settings.js": [
		"cDbd",
		253
	],
	"./en-US/smartOrderingSettings.js": [
		"HcM0",
		82
	],
	"./en-US/status.js": [
		"PtL0",
		254
	],
	"./en-US/task.js": [
		"aFXA",
		255
	],
	"./en-US/team.js": [
		"qnHj",
		256
	],
	"./en-US/timeRange.js": [
		"Cp/x",
		257
	],
	"./en-US/tipSettings.js": [
		"G487",
		259
	],
	"./en-US/tipsAllocation.js": [
		"7geu",
		260
	],
	"./en-US/transaction.js": [
		"EWpz",
		261
	],
	"./en-US/user.js": [
		"IdlB",
		262
	],
	"./en-US/userActivity.js": [
		"2xVq",
		263
	],
	"./en-US/waitlistSettings.js": [
		"xS63",
		264
	],
	"./en-US/workforce.js": [
		"bOGq",
		265
	],
	"./en.js": [
		"pjiS",
		82,
		81,
		104
	],
	"./zh-CN/accountSettings.js": [
		"+XF/",
		266
	],
	"./zh-CN/action.js": [
		"j0Rn",
		267
	],
	"./zh-CN/activities.js": [
		"YaOa",
		269
	],
	"./zh-CN/adjustment.js": [
		"LT1H",
		270
	],
	"./zh-CN/adyenMonthlyReport.js": [
		"9scJ",
		271
	],
	"./zh-CN/alternativePayments.js": [
		"BhwS",
		272
	],
	"./zh-CN/appConfig.js": [
		"oNhz",
		273
	],
	"./zh-CN/breakManagement.js": [
		"VKz9",
		274
	],
	"./zh-CN/cashStatement.js": [
		"i8c+",
		275
	],
	"./zh-CN/categories.js": [
		"cv0+",
		276
	],
	"./zh-CN/cfdSettings.js": [
		"UpC2",
		277
	],
	"./zh-CN/common.js": [
		"stLd",
		278
	],
	"./zh-CN/component.js": [
		"rLTg",
		112
	],
	"./zh-CN/customerPickupScreenSettings.js": [
		"qOqe",
		113
	],
	"./zh-CN/customizations.js": [
		"GpJG",
		114
	],
	"./zh-CN/deliveryPlatformOrderingSettings.js": [
		"Bd6O",
		115
	],
	"./zh-CN/department.js": [
		"wg8o",
		116
	],
	"./zh-CN/devices.js": [
		"S7Z4",
		117
	],
	"./zh-CN/discount.js": [
		"KHT6",
		118
	],
	"./zh-CN/dishEdit.js": [
		"8HjA",
		119
	],
	"./zh-CN/dishPreference.js": [
		"mW/k",
		120
	],
	"./zh-CN/dishes.js": [
		"hzAy",
		121
	],
	"./zh-CN/dynamicRateFeeReport.js": [
		"Z7LT",
		123
	],
	"./zh-CN/fee.js": [
		"Oo1J",
		124
	],
	"./zh-CN/filter.js": [
		"lP5W",
		125
	],
	"./zh-CN/floorPlan.js": [
		"G1Zs",
		126
	],
	"./zh-CN/formula.js": [
		"v7Hq",
		127
	],
	"./zh-CN/giftcardReport.js": [
		"K+v1",
		128
	],
	"./zh-CN/globalHeader.js": [
		"j+CN",
		129
	],
	"./zh-CN/globalPreferenceSettings.js": [
		"obJs",
		130
	],
	"./zh-CN/home.js": [
		"7a5M",
		131
	],
	"./zh-CN/kitchenDisplayScreenSettings.js": [
		"aGIm",
		132
	],
	"./zh-CN/loyalty.js": [
		"eaom",
		102
	],
	"./zh-CN/loyaltyMember.js": [
		"qCfQ",
		134
	],
	"./zh-CN/loyaltySettings.js": [
		"U8At",
		135
	],
	"./zh-CN/member.js": [
		"H+CL",
		136
	],
	"./zh-CN/menu.js": [
		"LSG6",
		137
	],
	"./zh-CN/menuBuilder.js": [
		"HCVr",
		138
	],
	"./zh-CN/menuDecorate.js": [
		"ptxl",
		139
	],
	"./zh-CN/menuDecorationPreview.js": [
		"e04o",
		140
	],
	"./zh-CN/menuManagement.js": [
		"tiPg",
		141
	],
	"./zh-CN/menuSettings.js": [
		"WgXs",
		142
	],
	"./zh-CN/monthlyStatement.js": [
		"JRhI",
		144
	],
	"./zh-CN/onlineOrderingSettings.js": [
		"L2ni",
		145
	],
	"./zh-CN/order.js": [
		"JNuu",
		146
	],
	"./zh-CN/orderDetail.js": [
		"DthQ",
		147
	],
	"./zh-CN/orderReviews.js": [
		"zPe7",
		148
	],
	"./zh-CN/password.js": [
		"gfPg",
		149
	],
	"./zh-CN/payout.js": [
		"IMdO",
		150
	],
	"./zh-CN/payoutFeeReport.js": [
		"jUOf",
		151
	],
	"./zh-CN/permission.js": [
		"suKQ",
		152
	],
	"./zh-CN/permissionManagement.js": [
		"pUZQ",
		153
	],
	"./zh-CN/prepaidTransactions.js": [
		"B3XO",
		155
	],
	"./zh-CN/priceEditor.js": [
		"f6r9",
		156
	],
	"./zh-CN/printTemplate.js": [
		"xr4f",
		157
	],
	"./zh-CN/printer.js": [
		"ZL4b",
		158
	],
	"./zh-CN/printerLogs.js": [
		"lVMt",
		159
	],
	"./zh-CN/printerMapping.js": [
		"lhmE",
		160
	],
	"./zh-CN/printoutSettings.js": [
		"VCAf",
		161
	],
	"./zh-CN/promotionManagement.js": [
		"ixmu",
		162
	],
	"./zh-CN/promotionSettings.js": [
		"0nC/",
		163
	],
	"./zh-CN/quickNotes.js": [
		"j+8O",
		164
	],
	"./zh-CN/reportsSettings.js": [
		"4HQG",
		166
	],
	"./zh-CN/request.js": [
		"w/i+",
		167
	],
	"./zh-CN/reservationSettings.js": [
		"+kng",
		168
	],
	"./zh-CN/resetPassword.js": [
		"j6ND",
		169
	],
	"./zh-CN/rgReport.js": [
		"xd1o",
		170
	],
	"./zh-CN/role.js": [
		"X4Lz",
		171
	],
	"./zh-CN/salesCategory.js": [
		"x3WC",
		172
	],
	"./zh-CN/salesReport.js": [
		"Bd3r",
		173
	],
	"./zh-CN/salesSummary.js": [
		"hA4P",
		174
	],
	"./zh-CN/servicePeriod.js": [
		"f2IB",
		175
	],
	"./zh-CN/serviceSettings.js": [
		"gb3c",
		177
	],
	"./zh-CN/settings.js": [
		"LzaK",
		178
	],
	"./zh-CN/smartOrderingSettings.js": [
		"lG24",
		103
	],
	"./zh-CN/status.js": [
		"x00h",
		179
	],
	"./zh-CN/task.js": [
		"hzF7",
		180
	],
	"./zh-CN/team.js": [
		"ERKw",
		181
	],
	"./zh-CN/timeRange.js": [
		"iJiI",
		182
	],
	"./zh-CN/tipSettings.js": [
		"mqhG",
		183
	],
	"./zh-CN/tipsAllocation.js": [
		"n1dl",
		184
	],
	"./zh-CN/transaction.js": [
		"NN/q",
		185
	],
	"./zh-CN/user.js": [
		"m+v0",
		187
	],
	"./zh-CN/userActivity.js": [
		"hvt0",
		188
	],
	"./zh-CN/waitlistSettings.js": [
		"6t5Z",
		189
	],
	"./zh-CN/workforce.js": [
		"3XcL",
		190
	],
	"./zh.js": [
		"Rn2z",
		103,
		102,
		191
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mKTV";
module.exports = webpackAsyncContext;